import dayjs from "dayjs";
export class LocalStorage {
    static setUserStorage(user) {
        localStorage.setItem("user", JSON.stringify(user));
    }
    static removeUserStorage() {
        localStorage.removeItem("user");
    }
    static getUserStorage() {
        return JSON.parse(localStorage.getItem("user"));
    }
    // Expire session
    static setSessionExpire() {
        const expire = dayjs().add(4, 'hours');
        localStorage.setItem('session-expire', expire);
    }
    static getSessionExpire() {
        return localStorage.getItem("session-expire");
    }
    static removeSessionExpire() {
        localStorage.removeItem("session-expire");
    }
    // Remove all local storage item
    static reset() {
        localStorage.clear();
    }
}
